import "./DestinationsFilters.scss";

const REGIONS = ["Midwest", "West", "Southwest"];

export default function DestinationsFilters({
  region,
  setRegion,
  tag,
  setTag,
  search,
  setSearch,
}) {
  return (
    <div className="destinations-filters">
      {/* Search */}
      <input
        type="text"
        placeholder="Search journeys..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* Region Chips */}
      <div className="region-chips">
        <button
          className={!region ? "active" : ""}
          onClick={() => setRegion("")}
        >
          All
        </button>

        {REGIONS.map((r) => (
          <button
            key={r}
            className={region === r ? "active" : ""}
            onClick={() => setRegion(r)}
          >
            {r}
          </button>
        ))}
      </div>

      {/* Tag Dropdown */}
      <select value={tag} onChange={(e) => setTag(e.target.value)}>
        <option value="">All Tags</option>
        <option value="Hiking">Hiking</option>
        <option value="Caves">Caves</option>
        <option value="Family Friendly">Family Friendly</option>
      </select>
    </div>
  );
}
